// extracted by mini-css-extract-plugin
export var actionButton = "_jz-t";
export var buttonContainer = "_jz-0";
export var buttonContainer2 = "_jz-1";
export var buttonSection = "_jz-2";
export var details = "_jz-3";
export var dropdownItem = "_jz-5";
export var dropdownItemsContainer = "_jz-4";
export var fileInput = "_jz-r";
export var headerButton = "_jz-6";
export var icon = "_jz-7";
export var input = "_jz-8";
export var macroListItem = "_jz-9";
export var mainContent = "_jz-a";
export var microText = "_jz-b";
export var modal = "_jz-w";
export var optionsButton = "_jz-c";
export var paperclip = "_jz-s";
export var pillContent = "_jz-d";
export var preview = "_jz-e";
export var preview2 = "_jz-f";
export var quillEditor = "_jz-q";
export var selectedMacro = "_jz-g";
export var sidebar = "_jz-h";
export var sidebarHeader = "_jz-j";
export var sidebarList = "_jz-i";
export var sidebarListItem = "_jz-k";
export var sidebarSearch = "_jz-l";
export var snoozeDurationWrapper = "_jz-v";
export var statusPillContainer = "_jz-m";
export var tagsContainer = "_jz-n";
export var unselectedMacro = "_jz-o";
export var variable = "_jz-u";
export var wrapper = "_jz-p";